// ** Third Party Imports
import {
	Controller,
	type Control,
	type FieldErrors,
	type UseFormTrigger
} from 'react-hook-form'

// ** Type Imports
import { type EnterpriseFormVariables } from '../../model/types'

// ** Component Imports
import { FormControl, FormHelperText, InputField } from '@/shared/ui'

// ** Styled Components
import { FieldsWrapper, InputsWrapper } from './styles'

interface IProps {
	errors: FieldErrors<EnterpriseFormVariables>
	control: Control<EnterpriseFormVariables>
	trigger: UseFormTrigger<any>
	className?: string
	onNewPublicPage?: boolean
}

export const Form = ({
	errors,
	control,
	trigger,
	className,
	onNewPublicPage
}: IProps) => {
	return (
		<>
			<FieldsWrapper $onNewPublicPage={onNewPublicPage}>
				<InputsWrapper className={className}>
					{/* First Name */}
					<FormControl name='firstName'>
						<Controller
							name='firstName'
							control={control}
							render={({ field: { value, onChange } }) => (
								<InputField
									name='firstName'
									value={value}
									label='First Name'
									error={errors.firstName}
									onChange={onChange}
									trigger={trigger}
									fullWidth
								/>
							)}
						/>

						{errors.firstName != null && (
							<FormHelperText color='error'>
								{errors.firstName.message as string}
							</FormHelperText>
						)}
					</FormControl>

					{/* Last Name */}
					<FormControl name='lastName'>
						<Controller
							name='lastName'
							control={control}
							render={({ field: { value, onChange } }) => (
								<InputField
									name='lastName'
									value={value}
									label='Last Name'
									error={errors.lastName}
									onChange={onChange}
									trigger={trigger}
									fullWidth
								/>
							)}
						/>

						{errors.lastName != null && (
							<FormHelperText color='error'>
								{errors.lastName.message as string}
							</FormHelperText>
						)}
					</FormControl>
				</InputsWrapper>

				<InputsWrapper className={className}>
					{/* Company Name */}
					<FormControl name='companyName'>
						<Controller
							name='companyName'
							control={control}
							render={({ field: { value, onChange } }) => (
								<InputField
									name='companyName'
									value={value}
									label='Company Name'
									error={errors.companyName}
									onChange={onChange}
									trigger={trigger}
									fullWidth
								/>
							)}
						/>

						{errors.companyName != null && (
							<FormHelperText color='error'>
								{errors.companyName.message as string}
							</FormHelperText>
						)}
					</FormControl>
				</InputsWrapper>

				<InputsWrapper className={className}>
					{/* Email */}
					<FormControl name='email'>
						<Controller
							name='email'
							control={control}
							render={({ field: { value, onChange } }) => (
								<InputField
									name='email'
									value={value}
									label='Email'
									error={errors.email}
									onChange={onChange}
									trigger={trigger}
									fullWidth
								/>
							)}
						/>

						{errors.email != null && (
							<FormHelperText color='error'>
								{errors.email.message as string}
							</FormHelperText>
						)}
					</FormControl>
				</InputsWrapper>

				<InputsWrapper className={className}>
					{/* Message */}
					<FormControl name='message'>
						<Controller
							name='message'
							control={control}
							render={({ field: { value, onChange } }) => (
								<InputField
									name='message'
									value={value}
									label='Message'
									error={errors.message}
									onChange={onChange}
									trigger={trigger}
									fullWidth
								/>
							)}
						/>

						{errors.message != null && (
							<FormHelperText color='error'>
								{errors.message.message as string}
							</FormHelperText>
						)}
					</FormControl>
				</InputsWrapper>
			</FieldsWrapper>
		</>
	)
}
